module.exports = __webpack_public_path__ + "static/media/improvement-idea-black.bb8f242d.png";